<template>
	<div class="container">
		<div class="form_box">
			<div class="form_el">
				<div class="form_el_el">
					<div class="tit require">First name</div>
					<input v-model="firstName" autocomplete="off" />
				</div>
			</div>
			<div class="form_el">
				<div class="form_el_el">
					<div class="tit require">Last name</div>
					<input v-model="lastName" autocomplete="off" />
				</div>
			</div>
			<div class="form_el">
				<div class="form_el_el">
					<div class="tit require">Email</div>
					<input v-model="email" autocomplete="off" />
				</div>
			</div>
			<div class="form_el">
				<div class="form_el_el">
					<div class="tit require">Subject</div>
					<input v-model="subject" autocomplete="off" />
				</div>
			</div>
			<div class="form_el">
				<div class="form_el_el">
					<div class="tit require">Message</div>
					<textarea v-model="message" autocomplete="off" />
				</div>
			</div>
			<div class="btn_box">
				<van-button color="#E37542" class="btn_el" @click="submit">Send Message</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import { submitMsg } from '@/api/public';  //提交留言
import md5 from 'js-md5';
export default {
	components:{
		//
	},
	data() {
		return {
			firstName: '',
			lastName: '',
			email: '',
			subject: '',
			message: ''
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	methods: {
		//点击提交
		submit() {
			let that = this;
			if(that.firstName && that.lastName && that.email && that.subject && that.message) {
				if(!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(that.email)) {
					that.$toast('Email must be formatted correctly.');
					return false;
				}
				that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
				submitMsg({
					first_name: that.firstName,
					last_name: that.lastName,
					email: that.email,
					subject: that.subject,
					message: that.message,
					access_token: md5(String(that.firstName)+String(that.lastName)+String(that.email)+String(that.message)+'JtestsByAiiso')
				}).then(res => {
					that.$toast.clear();
					that.firstName = '';
					that.lastName = '';
					that.email = '';
					that.subject = '';
					that.message = '';
					that.$toast('Submitted successfully');
				});
			}else {
				that.$toast('Please complete this required field.');
			}
		},
	}
}
</script>

<style lang="less" scoped>
.form_box{
	width: 100%;
	margin: 0 auto;
	color: #000000;
	.btn_box{
		margin-top: 35px;
		text-align: center;
		.btn_el{
			height: auto;
			padding: 8px 30px 4px 30px;
			font-size: 20px;
			border-radius: 6px;
		}
	}
	.form_el{
		.form_el_el{
			display: inline-block;
			width: 100%;
			textarea{
				width: 100%;
				height: 120px;
				padding: 10px 0;
				text-indent: 18px;
				color: #000000;
				font-size: 18px;
				background-color: #FDFDFD;
				border: 1px solid #BFBFBF;
				resize: none;
			}
			textarea:focus{
				border: 1px solid rgb(30, 93, 132);
			}
			input{
				width: 100%;
				height: 48px;
				list-style: 48px;
				text-indent: 18px;
				color: #000000;
				font-size: 18px;
				background-color: #FDFDFD;
				border: 1px solid #BFBFBF;
			}
			input:focus{
				border: 1px solid rgb(30, 93, 132);
			}
			.require::after{
				content: '*';
				color: #FF0000;
			}
			.tit{
				padding: 15px 0 5px 0;
				font-size: 18px;
				color: #006BB3;
			}
		}
	}
	.title{
		padding-bottom: 8px;
		font-size: 20px;
	}
}
</style>